import { useSearchParams } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import { DEFAULT_FILTERS } from '../utils/dashboardConstants';

export const useDashboardFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const filters = useMemo(() => ({
        run_date: searchParams.get('run_date') || null,
        policy_code: searchParams.get('policy_code') || '',
        partner_id: searchParams.get('partner_id') || '',
        company_name: searchParams.get('company_name') || '',
        reservation_number: searchParams.get('reservation_number') || '',
        activity_name: searchParams.get('activity_name') || '',
        distribution_type: searchParams.get('distribution_type') || '',
        include_completed: searchParams.get('include_completed') !== 'false',
        forecast_timing_hour: searchParams.has('forecast_timing_hour')
            ? Number(searchParams.get('forecast_timing_hour'))
            : null,
        match_current_hour: searchParams.get('match_current_hour') === 'true',
        scope: searchParams.get('scope') || 'all',
        observation_timing_hour: searchParams.has('observation_timing_hour')
            ? Number(searchParams.get('observation_timing_hour'))
            : null,
        trip_end_date_from: searchParams.get('trip_end_date_from') || null,
        trip_end_date_to: searchParams.get('trip_end_date_to') || null,
    }), [searchParams]);

    const setFilters = useCallback((values) => {
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            Object.entries(values).forEach(([key, value]) => {
                if (!(key in DEFAULT_FILTERS)) return;
                if (value === null || value === undefined || value === '' || value === DEFAULT_FILTERS[key]) {
                    next.delete(key);
                } else {
                    next.set(key, String(value));
                }
            });
            return next;
        });
    }, [setSearchParams]);

    const setFilter = useCallback((key, value) => {
        setFilters({ [key]: value });
    }, [setFilters]);

    const resetFilters = useCallback(() => {
        setSearchParams({});
    }, [setSearchParams]);

    const hasActiveFilters = useMemo(
        () => Array.from(searchParams.keys()).length > 0,
        [searchParams]
    );

    return { filters, setFilter, setFilters, resetFilters, hasActiveFilters };
};
